import React, { useState, useEffect } from "react";
import "../index.css";
import CtaButton from "../fragments/ctaButton";
import { MAILTO_HREF, onMailClick } from "../lib/mailLink";

const Home = () => {
  const [currentDate] = useState(getDate());
  const [scrambledDesigner, setScrambledDesigner] = useState("");
  const finalDesignerText = "DESIGNER";

  function getDate() {
    const today = new Date();
    const months = [
      "Jan",
      "Feb",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ];
    const month = months[today.getMonth()];
    const date = today.getDate();
    return [date, month];
  }

  useEffect(() => {
    scrambleText(finalDesignerText);
  }, []);

  const scrambleText = (text) => {
    const characters = "ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789";
    let iterations = 0;

    const interval = setInterval(() => {
      setScrambledDesigner(
        text
          .split("")
          .map((char, index) => {
            if (index < iterations) {
              return char; // Keep revealed characters
            }
            return characters[Math.floor(Math.random() * characters.length)];
          })
          .join("")
      );

      if (iterations >= text.length) {
        clearInterval(interval);
        setScrambledDesigner(text); // Ensure final text is displayed
      }

      iterations += 1 / 2; // Adjust speed of character reveal
    }, 80); // Adjust interval duration for animation speed
  };

  return (
    <div className="relative w-full min-h-[80vh] mb-[20vh] flex items-center justify-center">
      <div className="flex flex-row justify-between grid grid-cols-1 md:grid-cols-2 lg:grid-cols-2 gap-4 text-primaryFont">
        <div className="hidden md:block"></div>
        {/* Top Right Section */}
        <div className="order-2 md:order-none px-5 md:px-10 2xl:px-20 md:translate-y-20">
          <div className="font-jack text-[70px] leading-[70px] lg:text-[100px] lg:leading-[50px] 2xl:text-[160px] 2xl:leading-[80px]">
            *{currentDate[0]}{" "}
            <span className="text-[40px] lg:text-[70px] 2xl:text-[120px]">
              {currentDate[1]}
            </span>
          </div>
          <div className="font-jack text-[16px] 2xl:text-[50px] lg:text-[30px] ml-5 lg:ml-9 2xl:ml-16 text-yellow">
            available for work
          </div>
          <div className="flex flex-col font-sora text-[15px] lg:text-[20px] 2xl:text-[40px] lg:ml-10 mx-5 2xl:ml-20">
            Software developer and designer by day. Fiction reader by night. Somewhere in between is where I live.
          </div>

          <CtaButton
            href={MAILTO_HREF}
            onClick={onMailClick}
            className="mt-6 mr-5 ml-auto md:ml-5 md:mr-auto lg:ml-10 2xl:ml-20"
          >
            Say hi!
          </CtaButton>
        </div>

        {/* Bottom Left Section */}
        <div className="order-1 md:order-none flex flex-col pb-16 md:pb-0 md:px-10 px-5 2xl:px-20">
          <div className="font-jack text-primaryFont text-[30px] leading-[30px] lg:text-[50px] lg:leading-[50px] 2xl:text-[70px] 2xl:leading-[80px] mb-2 lg:mb-5">
            creative
          </div>
          <div className="font-tuskerBold text-yellow text-[100px] leading-[100px] md:text-[100px] md:leading-[100px] lg:text-[150px] lg:leading-[120px] 2xl:text-[300px] 2xl:leading-[300px]">
            {scrambledDesigner}
            <span className="font-jack text-[50px] lg:text-[70px] 2xl:text-[100px] text-primaryFont">
              &
            </span>
          </div>
          <div className="text-primaryFont font-tuskerBold text-[100px] leading-[50px] md:text-[100px] md:leading-[50px] lg:text-[150px] lg:leading-[100px] 2xl:text-[300px] 2xl:leading-[150px]">
            DEVELOPER
          </div>
        </div>

      </div>
    </div>
  );
};

export default Home;
